import { d as oe } from "./disableTabulationOnNotActiveSlidesWithModel-5413c83c.js";
const Ee = () => {
        const s = {
            section: "[data-section-type='product']",
            container: "[data-js-product-form]",
            product: "[data-js-product-json]",
            sku: ".js-product-sku",
            price: ".js-price",
            productPrice: "[data-product-price]",
            productPriceOld: "[data-price-old]",
            priceUnit: "[data-js-unit-price]",
            productSalePercentageBadge: ".js-sale-percentage-badge",
            productSalePercentage: "[data-sale-percentage]",
            variantId: '[name="id"]',
            submit: '[type="submit"]',
            quantityError: ".js-product-quantity-error",
            quantityErrorWrapper: ".js-product-quantity-error-wrapper",
            variants: "[data-js-product-variant]",
            variantElemJSON: "[data-selected-variant]",
            isPreset: "[data-is-preset]",
            productInventory: ".js-product-inventory",
            stickyBar: ".js-sticky-add-to-cart",
            stickyBarButton: ".js-sticky-add-to-cart-button",
            recipientCheckbox: ".js-recipient-form-checkbox",
            recipientFieldsContainer: ".js-recipient-form-fields",
            recipientField: ".js-recipient-form-field",
            recipientTimeZoneOffset: ".js-recipient-form-timezone-offset",
            recipientNoJsControl: ".js-recipient-form-no-js-control",
            animate: ".js-animate",
            breaksVal: ".js-price-breaks-val",
            volumePricing: ".js-product-volume-pricing",
            quantityRuleMin: ".js-product-quantity-rule-min",
            quantityRuleMax: ".js-product-quantity-rule-max",
            quantityRuleIncrement: ".js-product-quantity-rule-increment",
            quantityRuleMinVal: ".js-product-quantity-rule-min-val",
            quantityRuleMaxVal: ".js-product-quantity-rule-max-val",
            quantityRuleIncrementVal: ".js-product-quantity-rule-increment-val",
            volumePricingList: ".js-product-volume-pricing-list",
            volumePricingJSON: "[data-product-qty-breaks-json]",
            volumePricingShowMore: ".js-product-volume-pricing-show-more",
            priceVolume: ".js-price-volume",
            formError: ".js-form-error",
            swatchLabelName: ".js-swatch-label-name",
            quantityRules: ".js-product-quantity-rules",
            desktopMediaContainer: ".js-product-media-grid-desktop",
            mediaItem: ".js-product-gallery-slide",
            mediaLayout: "[data-media-layout]",
        };
        let a = {};
        const V = { id: "id", isCurrencyEnabled: "data-currency-code-enabled" },
            A = new Map();
        let H = new AbortController(),
            R = new AbortController(),
            Z,
            g,
            T,
            S,
            $,
            W,
            I = [],
            v = [];
        function G() {
            window.themeCore.utils.arrayIncludes,
                (Z = window.themeCore.utils.convertFormData),
                (g = window.themeCore.utils.QuantityWidget),
                (T = window.themeCore.utils.cssClasses),
                (S = window.themeCore.utils.formatMoney),
                ($ = window.themeCore.utils.getUrlWithVariant),
                (W = window.themeCore.utils.isIosDevice),
                (a = {
                    ...T,
                    onSale: "price--on-sale",
                    hidePrice: "price--hide",
                    animate: "js-animate",
                    animated: "animated",
                }),
                (I = de()),
                (v = pe()),
                K(),
                L(),
                ue(),
                ge(),
                me(),
                fe();
        }
        function K() {
            v.forEach(({ container: e }) => {
                e.addEventListener("change", se), e.addEventListener("submit", ae);
            }),
                window.themeCore.EventBus.listen("cart:updated", function (e) {
                    e &&
                        e.items &&
                        I.forEach(function (t) {
                            const n = Q(t),
                                r = Y(n);
                            X(t, n, r, !1), F(t, n), ee(t, r);
                        });
                });
        }
        function L() {
            v.length &&
                v.forEach(({ container: e }) => {
                    const t = e.getAttribute("id");
                    window.themeCore.EventBus.listen(`form:${t}:change-variant`, M);
                });
        }
        async function M({ currentVariant: e, elements: t, form: n, product: r, isTrusted: o }) {
            const i = Y(e);
            o &&
                (await k(e, r.handle, n),
                B(e, n),
                z(t, e),
                z({ skuContainer: t.mobileSkuContainer }, e),
                O(t, e),
                N(r, e, n),
                x(t, e),
                q(t),
                J(t, e),
                _(e, n)),
                X(n, e, i, o),
                F(n, e),
                ee(n, i);
        }
        async function k(e, t, n) {
            var c;
            const r = n.closest(s.section),
                o = r == null ? void 0 : r.querySelector(s.desktopMediaContainer);
            if (!o || !e || !e.featured_media) return;
            const i = o.dataset.desktopProductMediaContainerId,
                u = Number((c = o.querySelector(s.mediaItem)) == null ? void 0 : c.dataset.mediaId);
            if (window.matchMedia("(min-width: 1200px)").matches) {
                const l = document.querySelectorAll(s.mediaItem),
                    d = [...l].findIndex((f) => Number(f.dataset.mediaId) === e.featured_media.id),
                    p = l[d];
                if ((p == null ? void 0 : p.closest(s.mediaLayout).dataset.mediaLayout) === "stacked") {
                    const f = p.getBoundingClientRect();
                    (f.top >= 0 && f.bottom <= window.innerHeight) ||
                        requestAnimationFrame(() => {
                            p.scrollIntoView({ behavior: "smooth", block: "center" });
                        });
                }
            }
            if (!(!i || u === e.featured_media.id))
                return fetch(`${window.location.origin}/products/${t}?section_id=${i}&variant=${e.id}`)
                    .then((l) => l.text())
                    .then((l) => {
                        var p;
                        const d =
                            (p = new DOMParser().parseFromString(l, "text/html")) == null
                                ? void 0
                                : p.querySelector(s.desktopMediaContainer);
                        d && (o.replaceWith(d), window.themeCore.EventBus.emit(`product-media:${i}-update-complete`));
                    })
                    .catch((l) => {
                        console.error(l);
                    });
        }
        function _(e, t) {
            const n = t.querySelector("pickup-availability");
            n && (e && e.available ? n.fetchAvailability(e.id) : (n.removeAttribute("available"), (n.innerHTML = "")));
        }
        function B(e, t) {
            const n = t.querySelector(s.swatchLabelName);
            if (!n) return;
            if (!e) {
                const u = n.getAttribute("data-swatch-name"),
                    c = t.querySelector(`[data-option='${u}']:checked`);
                c && (n.textContent = c.value);
                return;
            }
            const o = "option" + n.getAttribute("data-swatch-position"),
                i = e[o];
            i && (n.textContent = i);
        }
        function O({ priceContainers: e }, t) {
            if (t) {
                if (!e.length) return;
            } else {
                e.forEach((n) => n.classList.add(a.hidePrice)), D(e, {});
                return;
            }
            e.forEach((n) => {
                const o = n.hasAttribute(V.isCurrencyEnabled)
                        ? window.themeCore.objects.shop.money_with_currency_format
                        : window.themeCore.objects.shop.money_format,
                    { price: i, compare_at_price: u } = t,
                    c = u > i,
                    l = S(i, o),
                    d = S(u, o);
                n.classList.remove(a.hidePrice), c ? n.classList.add(a.onSale) : n.classList.remove(a.onSale);
                const p = n.querySelectorAll(s.productPrice),
                    h = n.querySelectorAll(s.productPriceOld);
                p.forEach((f) => (f.innerHTML = l)), h.forEach((f) => (f.innerHTML = d));
				debugger;
				p.forEach(function(element) {
                    element.classList.remove("wpd-processed");					
					element.setAttribute("data-wpd-variant-id", t.id);
					element.setAttribute("data-wpd-variant-compare-at-price",t.compare_at_price == null ? "":t.compare_at_price);
					element.setAttribute("data-wpd-variant-price",t.price);

				});
            }),
                D(e, t);
        }
        function N(e, t, n) {
            const o = n.closest(s.section).querySelectorAll(s.productSalePercentageBadge);
            if (o.length) {
                if (!t || !e || !e.available) {
                    o.forEach((i) => i.classList.add(a.hidden));
                    return;
                }
                o.forEach((i) => {
                    const u = i.querySelector(s.productSalePercentage);
                    if (!u) {
                        i.classList.add(a.hidden);
                        return;
                    }
                    const { price: c, compare_at_price: l } = t;
                    if (l > c) {
                        const p = Math.floor(((l - c) * 100) / l);
                        (u.innerHTML = window.themeCore.translations.get("products.product.sale_percentage_label", {
                            number: p,
                        })),
                            i.classList.remove(a.hidden);
                    } else i.classList.add(a.hidden);
                });
            }
        }
        function D(e, t) {
            e.forEach((n) => {
                const r = [...n.querySelectorAll(s.priceUnit)];
                if (!r.length) return;
                const o = r.find((d) => d.dataset.jsUnitPrice === "container"),
                    i = r.find((d) => d.dataset.jsUnitPrice === "money"),
                    u = r.find((d) => d.dataset.jsUnitPrice === "reference"),
                    c = t.unit_price,
                    l = t.unit_price_measurement;
                if (i)
                    if (c) {
                        const d = window.themeCore.objects.shop.money_format;
                        i.innerHTML = S(c, d);
                    } else i.innerHTML = "";
                if (u)
                    if (l) {
                        const d = l.reference_value,
                            p = l.reference_unit;
                        u.innerHTML = d !== 1 ? d + p : p;
                    } else u.innerHTML = "";
                o && (c || l) ? o.classList.remove(a.hidden) : o.classList.add(a.hidden);
            });
        }
        function z({ skuContainer: e }, t) {
            if (!e) return;
            let n = null;
            if ((t && (n = t.sku), !n)) {
                const o = e.closest(s.isPreset);
                if (o && o.dataset.isPreset === "true") return;
                e.innerHTML = "";
                return;
            }
            const r = e.dataset.skuText;
            e.innerHTML = r ? r.replaceAll("{SKU}", n).replaceAll("{sku}", n) : n;
        }
        function x({ variantIdContainer: e }, t) {
            if (!e || !t) return;
            const { id: n } = t;
            e.value = n;
        }
        function q({ quantityError: e }) {
            e && (e.innerHTML = "");
        }
        function J({ submit: e }, t) {
            const n = e.find((h) => !h.matches(s.stickyBarButton)),
                r = (h) => e.forEach((f) => (f.disabled = h)),
                o = window.themeCore.utils.icons.loader,
                i = (h) => {
                    var f;
                    n.innerHTML =
                        ((f = n == null ? void 0 : n.dataset) == null ? void 0 : f.type) === "primary"
                            ? `<span data-loading>${h}</span>${o}`
                            : `<span data-text="${h}"><span>${h}</span></span>${o}`;
                },
                u = e.some((h) => h.hasAttribute("data-preorder")),
                c = window.themeCore.translations.get("products.product.sold_out"),
                l = window.themeCore.translations.get("products.product.unavailable"),
                d = window.themeCore.translations.get("products.product.pre_order"),
                p = u ? d : window.themeCore.translations.get("products.product.add_to_cart");
            t && t.available ? (r(!1), i(p)) : t && !t.available ? (r(!0), i(c)) : (r(!0), i(l));
        }
        function F(e, t) {
            const r = v.find((f) => f.container.getAttribute("id") === e.getAttribute("id")).elements.quantityWidgetEl,
                o = e.querySelector(s.quantityRules);
            if (!o) return;
            if (!t || (t && !t.quantity_rule)) {
                o.classList.add(a.hidden);
                return;
            } else o.classList.remove(a.hidden);
            const i = t.quantity_rule,
                u = o.querySelector(s.quantityRuleIncrement),
                c = o.querySelector(s.quantityRuleMin),
                l = o.querySelector(s.quantityRuleMax),
                d = o.querySelector(s.quantityRuleIncrementVal),
                p = o.querySelector(s.quantityRuleMinVal),
                h = o.querySelector(s.quantityRuleMaxVal);
            d &&
                ((d.textContent = window.themeCore.translations.get("products.product.increments_of", {
                    number: i.increment,
                })),
                r.setIncrement(i.increment),
                i.increment > 1 ? u.classList.remove(a.hidden) : u.classList.add(a.hidden)),
                p &&
                    ((p.textContent = window.themeCore.translations.get("products.product.minimum_of", {
                        number: i.min,
                    })),
                    r.setMin(i.min),
                    r.toggleDecrease(),
                    r.toggleIncrease(),
                    i.min > 1 ? c.classList.remove(a.hidden) : c.classList.add(a.hidden)),
                h &&
                    (i.max !== null
                        ? ((h.textContent = window.themeCore.translations.get("products.product.maximum_of", {
                              number: i.max,
                          })),
                          l.classList.remove(a.hidden),
                          r.setMax(i.max))
                        : ((h.textContent = ""), l.classList.add(a.hidden), r.setMax("")),
                    r.toggleDecrease(),
                    r.toggleIncrease()),
                i.increment < 2 && i.min < 2 && i.max === null
                    ? o.classList.add(a.hidden)
                    : o.classList.remove(a.hidden);
        }
        function X(e, t, n, r) {
            const i = v.find((m) => m.container.getAttribute("id") === e.getAttribute("id")).elements.quantityWidgetEl;
            if (!e.querySelector("[name=id]")) return;
            const c = e.querySelector(s.volumePricing),
                l = e.querySelector(s.volumePricingList),
                d = e.querySelector(s.volumePricingJSON);
            let p = null;
            if (!d || !c) return;
            if (t) {
                if (((p = JSON.parse(d.innerHTML)[t.id].quantity_price_breaks), f(p), !r)) return;
                p.length ? (h(p), c.classList.remove(a.hidden)) : c.classList.add(a.hidden);
            } else c.classList.add(a.hidden);
            function h(m) {
                const y = e.querySelector(s.volumePricingShowMore),
                    w = window.themeCore.objects.shop.money_with_currency_format,
                    P = window.themeCore.translations.get("products.product.volume_pricing.each", {
                        price: S(t.price, w),
                    });
                y.addEventListener("click", function (b) {
                    b.preventDefault();
                    let j = l.querySelectorAll(".is-hidden");
                    j.length &&
                        (j.forEach(function (U) {
                            U.classList.remove(a.hidden);
                        }),
                        y.classList.add(a.hidden));
                }),
                    (l.innerHTML = "");
                let C = `
				<li class="product-volume-pricing__list-item">
					<span>${t.quantity_rule.min}<span aria-hidden>+</span></span>
					<span>${P}</span>
				</li>
			`;
                l.insertAdjacentHTML("beforeend", C),
                    m.forEach(function (b, j) {
                        let E = `
					<li class="product-volume-pricing__list-item ${j >= 2 ? `${a.hidden}` : ""}">
						<span>${b.minimum_quantity}<span aria-hidden>+</span></span>
						<span>${b.price_each}</span>
					</li>
				`;
                        l.insertAdjacentHTML("beforeend", E);
                    }),
                    m.length >= 3 ? y.classList.remove(a.hidden) : y.classList.add(a.hidden);
            }
            function f(m) {
                const y = e.querySelectorAll(s.priceVolume),
                    w = window.themeCore.objects.shop.money_with_currency_format,
                    P = window.themeCore.translations.get("products.product.volume_pricing.price_at_each", {
                        price: S(t.price, w),
                    });
                if (!y.length) return;
                if (!t) {
                    y.forEach((b) => b.classList.add(a.hidden));
                    return;
                }
                if (!m || !m.length) {
                    y.forEach((b) => (b.innerHTML = P)), y.forEach((b) => b.classList.remove(a.hidden));
                    return;
                }
                const C = m.findLast((b) => Number(n) + Number(i.quantity.value) >= b.minimum_quantity);
                if (!C) {
                    y.forEach((b) => (b.innerHTML = P)), y.forEach((b) => b.classList.remove(a.hidden));
                    return;
                }
                y.forEach((b) => (b.innerHTML = C.price_at_each)), y.forEach((b) => b.classList.remove(a.hidden));
            }
        }
        function Y(e) {
            const t = window.themeCore.cartObject;
            if (!t || !e) return;
            if (!t.items.length) return 0;
            const n = t.items.find(function (r) {
                return r.variant_id === e.id;
            });
            return n ? n.quantity : 0;
        }
        function ee(e, t) {
            if (!e) return;
            const n = e.querySelector(s.breaksVal);
            n &&
                (n.classList.toggle(a.hidden, !t),
                t || (n.innerHTML = ""),
                (n.innerHTML = window.themeCore.translations.get("products.product.quantity_in_cart", {
                    quantity: t,
                })));
        }
        async function se({ currentTarget: e, target: t, isTrusted: n }) {
            const r = v.find(({ container: E, elements: { optionElements: te } }) => e === E);
            if (!r) return;
            if (t.hasAttribute("data-quantity-input")) {
                let E = Q(e),
                    te = Y(E);
                X(e, E, te, !1), F(e, E), ee(e, te);
            }
            if (!t || !t.hasAttribute("data-option")) return;
            t.tagName === "SELECT" &&
                t.selectedOptions.length &&
                (Array.from(t.options)
                    .find((E) => E.getAttribute("selected"))
                    .removeAttribute("selected"),
                t.selectedOptions[0].setAttribute("selected", "selected"));
            const o = e.closest("[data-section-type=product]"),
                i = o.getAttribute("data-section-id"),
                u = o.getAttribute("data-url"),
                c = e.querySelector(".js-product-options");
            if (!c) return;
            const l = Array.from(
                    c.querySelectorAll("select[data-option] option[selected], input[data-option]:checked")
                ).map(({ dataset: E }) => E.optionValueId),
                d = l.length > 0 ? `&option_values=${l.join(",")}` : "",
                p = `${u}?section_id=${i}${d}`;
            let h;
            const f = A.get(p);
            if (f) h = f;
            else
                try {
                    H.abort(),
                        (H = new AbortController()),
                        (h = await (await fetch(p, { signal: H.signal })).text()),
                        A.set(p, h);
                } catch {
                    return;
                }
            re(e);
            const m = new DOMParser().parseFromString(h, "text/html");
            c.innerHTML = m.querySelector(".js-product-options").innerHTML;
            let y = Q(c),
                w = r.elements,
                P = r.product,
                C = e.querySelector(s.volumePricingJSON);
            C && m.querySelector(s.volumePricingJSON) && (C.innerHTML = m.querySelector(s.volumePricingJSON).innerHTML),
                (t.tagName !== "SELECT" || !W()) &&
                    document.querySelector(`#${t.id}`) &&
                    document.querySelector(`#${t.id}`).focus();
            const j = e.getAttribute("id");
            window.themeCore.EventBus.emit(`form:${j}:change-variant`, {
                form: e,
                product: P,
                currentVariant: y,
                elements: w,
                isTrusted: n,
            }),
                y &&
                    window.themeCore.EventBus.emit(`pdp:section-${i}:change-variant`, {
                        variantId: y.id,
                        variant: y,
                        product: P,
                        firstInitialization: !1,
                    });
            let U = e.querySelector(s.productInventory);
            U && m.querySelector(s.productInventory) && (U.outerHTML = m.querySelector(s.productInventory).outerHTML),
                ie(e) && ne(y);
        }
        function ae(e) {
            const t = e.target;
            e.preventDefault();
            const n = v.find((i) => i.id === t.getAttribute(V.id));
            if (n) {
                const { submit: i } = n.elements;
                i.forEach((u) => u.classList.add(a.loading));
            }
            const r = new FormData(t),
                o = Z(r);
            window.themeCore.CartApi.makeRequest(window.themeCore.CartApi.actions.ADD_TO_CART, o)
                .then((i) => {
                    ce(i, n);
                })
                .catch((i) => {
                    le(i, n);
                });
        }
        function ce(e, t) {
            if (!t) return;
            const n = t.container,
                { quantityWidgetEl: r, submit: o } = t.elements;
            r && r.setValue(0),
                o.forEach((i) => i.classList.remove(a.loading)),
                be(n),
                window.themeCore.CartApi.makeRequest(window.themeCore.CartApi.actions.GET_CART);
        }
        function le(e, t) {
            if (!t) return;
            const n = t.container,
                r = n.querySelector(s.recipientCheckbox);
            let { description: o } = e;
            const { quantityError: i, submit: u } = t.elements,
                c = n.querySelector(s.quantityErrorWrapper);
            if (typeof o == "object" && r) {
                const l = t.container.dataset.sectionId;
                let d = e.errors;
                const p = n.querySelectorAll(s.formError),
                    h = n.querySelectorAll(s.recipientField);
                return (
                    p.length &&
                        h.length &&
                        (p.forEach(function (f) {
                            f.classList.add(a.hidden), (f.innerText = "");
                        }),
                        h.forEach(function (f) {
                            f.setAttribute("aria-invalid", !1), f.removeAttribute("aria-describedby");
                        })),
                    Object.entries(d).forEach(([f, m]) => {
                        const y = `RecipientForm-${f}-error-${l}`,
                            w = n.querySelector(`#${y}`),
                            P = `Recipient-${f}-${l}`,
                            C = n.querySelector(`#${P}`);
                        let b = `${m.join(", ")}`;
                        f === "send_on" && (b = `${m.join(", ")}`),
                            w && ((w.innerText = b), w.classList.remove(a.hidden)),
                            C && (C.setAttribute("aria-invalid", !0), C.setAttribute("aria-describedby", y)),
                            u.forEach((j) => j.classList.remove(a.loading));
                    })
                );
            }
            i &&
                c &&
                ((i.innerHTML = o),
                c.classList.remove(a.hidden),
                window.themeCore.CartApi.makeRequest(window.themeCore.CartApi.actions.UPDATE_CART, { noOpen: !0 })),
                u.forEach((l) => l.classList.remove(a.loading));
        }
        function Q(e) {
            if (!e) return;
            const t = e.querySelector(s.variantElemJSON);
            return t ? JSON.parse(t.innerHTML) : null;
        }
        function ne(e) {
            if (!e) return null;
            const t = $(window.location.href, e.id);
            window.history.replaceState({ path: t }, "", t);
        }
        function ie(e) {
            return e.dataset.enableHistoryState || !1;
        }
        function ue() {
            v.forEach(async (e) => {
                let t = Q(e.container);
                if (
                    (M({
                        currentVariant: t,
                        elements: e.elements,
                        form: e.container,
                        product: e.product,
                        isTrusted: !0,
                    }),
                    t)
                ) {
                    const r = e.container.closest("[data-section-type=product]").getAttribute("data-section-id");
                    window.themeCore.EventBus.emit(`pdp:section-${r}:change-variant`, {
                        variantId: t.id,
                        variant: t,
                        product: e.product,
                        firstInitialization: !0,
                    });
                }
                ie(e.container) && ne(t), await re(e.container);
            });
        }
        function de() {
            return [...document.querySelectorAll(s.container)];
        }
        function pe() {
            return I.reduce((e, t) => {
                const n = t.querySelector(s.product);
                let r = {};
                try {
                    r = JSON.parse(n.innerHTML);
                } catch {
                    return e;
                }
                const o = t.getAttribute(V.id),
                    i = [...t.querySelectorAll(s.submit)],
                    u = t.querySelector(s.sku),
                    c = [...t.querySelectorAll(s.price)],
                    l = t.querySelector(s.quantityError),
                    d = t.querySelector(s.variantId);
                let p = [...t.querySelectorAll("[data-option]")],
                    h = null;
                const f = g(t, {
                    onQuantityChange: (m) => {
                        q({ quantityError: l });
                    },
                }).init();
                return [
                    ...e,
                    {
                        id: o,
                        container: t,
                        product: r,
                        elements: {
                            skuContainer: u,
                            priceContainers: c,
                            quantityWidgetEl: f,
                            quantityError: l,
                            variantIdContainer: d,
                            submit: i,
                            mobileSkuContainer: h,
                            optionElements: p,
                        },
                    },
                ];
            }, []);
        }
        function me() {
            I.forEach((e) => {
                const t = e.querySelector(s.stickyBar),
                    n = e.querySelector(s.submit);
                if (!t || !n) return;
                new IntersectionObserver((o) => {
                    o.forEach((i) => {
                        const u = n.getBoundingClientRect();
                        if ((t.classList.toggle(a.active, !i.isIntersecting && u.bottom < 0), !i.isIntersecting)) {
                            const c = t.closest(s.animate);
                            c && c.classList.remove(a.animate), c && c.classList.add(a.animated);
                        }
                    });
                }, {}).observe(n),
                    t.addEventListener("click", (o) => {
                        o.target.closest(s.stickyBarButton) && n.focus();
                    });
            });
        }
        function fe() {
            I.forEach((e) => {
                const t = e.querySelector(s.recipientCheckbox),
                    n = e.querySelector(s.recipientFieldsContainer),
                    r = e.querySelectorAll(s.recipientField),
                    o = e.querySelector(s.recipientTimeZoneOffset),
                    i = e.querySelector(s.recipientNoJsControl);
                if (!t || !n || !r || !o) return;
                (o.value = new Date().getTimezoneOffset().toString()),
                    (i.disabled = !0),
                    (t.disabled = !1),
                    u(),
                    t.addEventListener("change", function () {
                        t.checked ? (n.classList.remove(a.hidden), c()) : (n.classList.add(a.hidden), u());
                    });
                function u() {
                    r.forEach(function (l) {
                        l.disabled = !0;
                    }),
                        (o.disabled = !0);
                }
                function c() {
                    r.forEach(function (l) {
                        l.disabled = !1;
                    }),
                        (o.disabled = !1);
                }
            });
        }
        function he(e) {
            if (!e.querySelector(s.recipientCheckbox)) return;
            const r = e.querySelector(s.recipientFieldsContainer).querySelectorAll(s.formError),
                o = e.querySelectorAll(s.recipientField);
            !r ||
                !o ||
                (r.forEach(function (i) {
                    i.classList.add(a.hidden), (i.innerText = "");
                }),
                o.forEach(function (i) {
                    i.setAttribute("aria-invalid", !1), i.removeAttribute("aria-describedby");
                }));
        }
        function ye(e) {
            if (!e.querySelector(s.recipientCheckbox)) return;
            const n = e.querySelectorAll(s.recipientField);
            n &&
                n.forEach(function (r) {
                    r.value = "";
                });
        }
        function be(e) {
            const t = e.querySelector(s.recipientCheckbox);
            t && t.checked && ((t.checked = !1), t.dispatchEvent(new Event("change")), he(e), ye(e));
        }
        function ge() {
            I.forEach((e) => {
                const t = e.querySelector(s.variants);
                t && t.dataset.jsProductVariant !== "no-hidden" && t.classList.add(a.hidden);
            });
        }
        function we(e) {
            const t = e.reduce((u, c) => (u[c.name] || (u[c.name] = []), u[c.name].push(c), u), {}),
                n = Object.values(t);
            function r(u) {
                return u.reduce(
                    (c, l) => {
                        const d = [];
                        return (
                            c.forEach((p) => {
                                l.forEach((h) => {
                                    d.push([...p, h]);
                                });
                            }),
                            d
                        );
                    },
                    [[]]
                );
            }
            return r(n).map((u) => ({
                option_values: u.map((c) => c.value).join(","),
                selected: u.every((c) => c.selected),
                options: u,
            }));
        }
        function ve(e) {
            const t = e.find((r) => r.selected);
            if (!t) return e;
            const n = t.options.map((r) => r.value);
            return e.sort((r, o) => {
                const i = r.options.filter((d) => n.includes(d.value)).length,
                    u = o.options.filter((d) => n.includes(d.value)).length,
                    c = n.length - i,
                    l = n.length - u;
                return c !== l ? c - l : 0;
            });
        }
        async function Se(e) {
            const t = await fetch(e, { signal: R.signal });
            if (!t.ok) throw new Error(`HTTP error! status: ${t.status}`);
            return await t.text();
        }
        async function re(e) {
            const t = e.querySelector(".js-product-options");
            if (!t) return;
            const n = e.closest("[data-section-type=product]"),
                r = n.getAttribute("data-section-id"),
                o = n.getAttribute("data-url"),
                i = Array.from(t.querySelectorAll("select[data-option] option, input[data-option]")).map((m) => {
                    var y, w;
                    return {
                        name:
                            m.dataset.option ||
                            ((w = (y = m.closest("select")) == null ? void 0 : y.dataset) == null ? void 0 : w.option),
                        value: m.dataset.optionValueId,
                        selected: m.matches("[selected], :checked"),
                    };
                }),
                u = we(i),
                p = ve(u)
                    .filter((m) => !Array.from(A.keys()).some((y) => y.includes(m.option_values)))
                    .slice(0, 20)
                    .map(({ option_values: m }) => `${o}?section_id=${r}&option_values=${m}`);
            R.abort(), (R = new AbortController());
            const h = p.map((m) => Se(m));
            (await Promise.allSettled(h)).forEach((m, y) => {
                if (m.status === "fulfilled") {
                    const w = p[y];
                    A.set(w, m.value);
                }
            });
        }
        function qe() {
            return v;
        }
        return Object.freeze({ init: G, allForms: qe });
    },
    Le = ({ config: s, selectors: a, sectionId: V }) => {
        const A = window.themeCore.utils.Swiper,
            H = window.themeCore.utils.on,
            R = window.themeCore.utils.extendDefaults;
        a = R(
            {
                slider: ".js-product-media-slider",
                sliderPagination: ".js-product-media-slider-pagination",
                activeClass: ".swiper-slide-active",
                modelPoster: ".js-product-media-model-poster",
                notInitedIframe: ".js-video.js-video-youtube, .js-video:empty",
                sliderThumbnails: ".js-product-media-slider-thumbnails",
            },
            a
        );
        let g = null,
            T = null,
            S = !1,
            $ = !0;
        function W() {
            if (S) return g;
            const L = document.querySelector(a.slider);
            let M = L.dataset.autoHeight;
            const k = document.querySelector(a.sliderThumbnails);
            let _ = L.dataset.dynamicPagination;
            if (((_ = _ === "true"), (M = M === "true"), k)) {
                const x = k.dataset.thumbnailsPosition;
                let q = "horizontal";
                x === "right" && (q = "vertical"),
                    q === "horizontal"
                        ? (T = new A(a.sliderThumbnails, {
                              direction: q,
                              slidesPerView: 5,
                              spaceBetween: 4,
                              freeMode: !0,
                              watchSlidesProgress: !0,
                              a11y: { slideRole: "" },
                              threshold: 10,
                              breakpoints: { 1200: { slidesPerView: 6, spaceBetween: 16 } },
                          }))
                        : (T = new A(a.sliderThumbnails, {
                              direction: "horizontal",
                              slidesPerView: 5,
                              spaceBetween: 4,
                              freeMode: !0,
                              watchSlidesProgress: !0,
                              threshold: 10,
                              breakpoints: { 1200: { direction: q, slidesPerView: 4, spaceBetween: 16 } },
                          })),
                    H("keydown", T.el, (J) => {
                        if (J.keyCode !== 13 && J.keyCode !== 32) return;
                        const F = J.target.dataset.slideIndex;
                        F && (T.slideTo(F), g.slideTo(F));
                    });
            }
            let B = document.querySelector(a.sliderNavigationPrev),
                O = document.querySelector(a.sliderNavigationNext);
            (g = new A(a.slider, {
                ...s,
                autoHeight: M,
                spaceBetween: 8,
                pagination: { el: ".swiper-pagination", clickable: !0, dynamicBullets: _, bulletElement: "button" },
                navigation: { nextEl: O, prevEl: B },
                thumbs: { swiper: T },
            })),
                g.on("slideChange", function (x) {
                    const q = x.slides[x.activeIndex];
                    q && (x.allowTouchMove = !(q.hasAttribute("data-model-slide") && !q.querySelector(a.modelPoster)));
                });
            const N = document.querySelector(a.slider),
                D = new MutationObserver(() => {
                    N.querySelector(a.notInitedIframe) || (oe(g), D.disconnect());
                }),
                z = { attributes: !0, childList: !0, subtree: !0 };
            D.observe(N, z), I(), (S = !0);
        }
        function I() {
            g &&
                (g.on("slideChange", function (L) {
                    window.themeCore.EventBus.emit("product-slider:slide-change"), oe(L);
                }),
                window.themeCore.EventBus.listen(`pdp:section-${V}:change-variant`, v));
        }
        function v({ variant: L }) {
            if (!g || !L) return;
            let M = null;
            L.featured_media && (M = L.featured_media.id);
            const k = [...g.slides].findIndex((B) => {
                const O = B.querySelector(a.sliderSlideVariantId);
                return O ? O.getAttribute("data-media-id").includes(M) : !1;
            });
            if (k === !1 || k === -1) return;
            const _ = g.el.hasAttribute("data-is-show-first-media-image");
            if ($ && _) {
                $ = !1;
                return;
            }
            g.slideTo(k);
        }
        function G() {
            g && S && (g.destroy(), (g = null)), (S = !1);
        }
        function K() {
            g && (g.allowTouchMove = !1);
        }
        return Object.freeze({ init: W, destroy: G, disableSwipe: K, onChangeVariant: v });
    };
export { Le as P, Ee as a };
